<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span>我的帳戶
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div new_user_center_box">
			
			<!--左侧菜单-开始-->
			<UserLeftPannel :fileName="'index'" :Token="this.token"></UserLeftPannel>
			<!--左侧菜单-结束-->
			
			<!--右侧内容-开始-->
			<div class="right_content_box">
				<h1>{{nickName}}你好!</h1>
				<div class="user_index_page">
					
					<div class="item_box">
						<div class="title_box">
							<h2>帳戶信息</h2>
							<div class="link"><a href="reset_password">重設密碼</a></div>
						</div>
						<ul>
							<li>
								<h5>帳號ID</h5>
								<p>{{userDetail.MemberCode}}</p>
							</li>
							<li>
								<h5>帳號名</h5>
								<p>{{userDetail.Email}}</p>
							</li>
						</ul>
					</div>
					
					<div class="item_box">
						<div class="title_box">
							<h2>個人資訊</h2>
							<div class="link"><a href="profile">編輯</a></div>
						</div>
						<ul>
							<li>
								<h5>姓名</h5>
								<p>{{userDetail.UserName !=''?userDetail.UserName:'未完善'}}</p>
							</li>
							<li>
								<h5>手機</h5>
								<p>{{userDetail.Mobile !=''?userDetail.Mobile:'未完善'}}</p>
							</li>
							<li>
								<h5>固定電話</h5>
								<p>{{userDetail.Telephone !=''?userDetail.Telephone:'未完善'}}</p>
							</li>
							<li>
								<h5>公司名稱</h5>
								<p>{{userDetail.Company !=''?userDetail.Company:'未完善'}}</p>
							</li>
							<li>
								<h5>詳細地址</h5>
								<p>{{userDetail.Address !=''?userDetail.Address:'未完善'}}</p>
							</li>
							<li>
								<h5>郵編</h5>
								<p>{{userDetail.ZipCode !=''?userDetail.ZipCode:'未完善'}}</p>
							</li>
							<li>
								<h5>國籍</h5>
								<p>{{userDetail.Country !=''?userDetail.Country:'未完善'}}</p>
							</li>
						</ul>
					</div>
					
				</div>
			</div>
			<!--右侧内容-结束-->			
		</div>
		
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		getUserProfile,
		userLogout,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import UserLeftPannel from '@/components/tw_user_left_pannel.vue'
	export default {
		name: 'TW_UserIndex',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			UserLeftPannel,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				userDetail: {},
				
				nickName: '',	//昵称
			}
		},
		created() {
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
			//获取数据
			async getData() {
				const { data: res } = await getUserProfile(this.language, this.token, this.terminal)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.userDetail = res.data
					
					if(this.userDetail.NickName !='')
					{
						this.nickName = this.userDetail.NickName +'，'
					}
				} else {
					this.errMessage = res.errmsg
				}
			},
			// 退出登录
			async userLogout()
			{
				let params={
					Token: this.token,
					Terminal: this.terminal,
				}
				
				const { data: res } = await userLogout(params)
				if (res.errcode === 0) {
					this.$storeage.remove('token')
					this.$storeage.remove('expire')
					this.token = null
					this.loginStatus = false
					
					this.$router.push({
						path: '/tw/user/login'
					})
				} else {
					this.$message.error(res.errmsg);
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*用户中心-首页*/
		.user_index_page {
			.item_box {
				margin-top: 60px;
				
				.title_box {
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					
					h2 {
						font-size: 20px;
						font-weight: 500;
					}
					
					.link {
						a {
							font-size: 15px;
							text-decoration: underline;
							color: #3D7856;							
						}
						a:hover {
							color: #000;
						}
					}
				}
				
				ul {
					width: 100%;
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
				}
				li {
					width: 49%;
					box-sizing: border-box;
					padding-right: 50px;
					margin-top: 24px;
					
					h5 {
						font-size: 15px;
						font-weight: 500;
					}
					p {
						margin-top: 4px;
						font-size: 14px;
						line-height: 140%;
					}
				}
				li:nth-child(2n) {
					padding-right: 0;
				}
			}
			
			.item_box:first-child {
				margin-top: 0;
			}
		}
	}
</style>